module.exports = __webpack_public_path__ + "img/Harvelles-7.26.24.47767f07.png";